(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["article"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const progress = document.getElementById('articleReadingProgress');
    const body = document.getElementById('articleBody');
    const tocList = document.getElementById('articleTocList');
    const mobileTocList = document.getElementById('mobileArticleTocList');
    const mobileToc = document.querySelector('.article-app-toc-mobile');
    const copyBtn = document.querySelector('[data-copy-link]');
    const tocLinks = [];
    let headings = [];

    function updateProgress() {
      if (!progress) return;
      const doc = document.documentElement;
      const scrollable = doc.scrollHeight - doc.clientHeight;
      const ratio = scrollable > 0 ? (doc.scrollTop / scrollable) * 100 : 0;
      progress.style.width = Math.min(100, Math.max(0, ratio)) + '%';
    }

    function setActiveHeading(id) {
      tocLinks.forEach(function (link) {
        const active = link.getAttribute('href') === '#' + id;
        link.classList.toggle('is-active', active);
        if (active) link.setAttribute('aria-current', 'location');
        else link.removeAttribute('aria-current');
      });
    }

    function updateActiveFromScroll() {
      if (!headings.length) return;
      const marker = 130;
      let current = headings[0];
      for (let i = 0; i < headings.length; i++) {
        const top = headings[i].getBoundingClientRect().top;
        if (top <= marker) current = headings[i];
        else break;
      }
      if (current && current.id) setActiveHeading(current.id);
    }

    window.addEventListener('scroll', function () {
      updateProgress();
      updateActiveFromScroll();
    }, { passive: true });
    updateProgress();

    if (body && (tocList || mobileTocList)) {
      headings = Array.from(body.querySelectorAll('.article-app-rte h2, .article-app-rte h3'));
      if (headings.length === 0) {
        const desktop = document.querySelector('.article-app-toc');
        if (desktop) desktop.hidden = true;
        if (mobileToc) mobileToc.hidden = true;
      } else {
        headings.forEach(function (heading, index) {
          if (!heading.id) {
            const slug = heading.textContent
              .trim()
              .toLowerCase()
              .replace(/[^a-z0-9]+/g, '-')
              .replace(/(^-|-$)/g, '');
            heading.id = slug || ('section-' + index);
          }

          [tocList, mobileTocList].forEach(function (list) {
            if (!list) return;
            const li = document.createElement('li');
            const a = document.createElement('a');
            a.href = '#' + heading.id;
            a.textContent = heading.textContent.trim();
            a.addEventListener('click', function () {
              if (mobileToc && mobileToc.open) mobileToc.open = false;
            });
            li.appendChild(a);
            list.appendChild(li);
            tocLinks.push(a);
          });
        });
        updateActiveFromScroll();
      }
    }

    if (copyBtn) {
      copyBtn.addEventListener('click', async function () {
        try {
          await navigator.clipboard.writeText(window.location.href);
          copyBtn.setAttribute('aria-label', 'Link copied');
          setTimeout(function () {
            copyBtn.setAttribute('aria-label', 'Copy link');
          }, 1600);
        } catch (e) {
          window.prompt('Copy this link', window.location.href);
        }
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blog"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const root = document.querySelector('.nimizo-blog-hub');
    if (!root) return;

    const input = root.querySelector('[data-blog-search]');
    const clearBtn = root.querySelector('[data-blog-search-clear]');
    const cards = root.querySelectorAll('[data-article-card]');
    const empty = root.querySelector('[data-blog-empty]');

    if (!input) return;

    function runSearch() {
      const q = input.value.trim().toLowerCase();
      if (clearBtn) clearBtn.hidden = q.length === 0;
      let visible = 0;

      cards.forEach((card) => {
        const hay = [
          card.dataset.title || '',
          card.dataset.excerpt || '',
          card.dataset.tags || '',
        ].join(' ').toLowerCase();
        const match = !q || hay.includes(q);
        card.style.display = match ? '' : 'none';
        if (match) visible += 1;
      });

      if (empty) empty.hidden = visible > 0;
    }

    input.addEventListener('input', runSearch);
    if (clearBtn) {
      clearBtn.addEventListener('click', function () {
        input.value = '';
        runSearch();
        input.focus();
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  (() => {
    const root = document.querySelector('.nimizo-bag');
    if (!root || !root.querySelector('[data-bag-form]')) return;

    const form = root.querySelector('[data-bag-form]');
    const setUpdating = (on) => root.classList.toggle('is-updating', on);

    const updateQuantities = async (key, quantity) => {
      setUpdating(true);
      try {
        const response = await fetch(window.Shopify?.routes?.root
          ? `${window.Shopify.routes.root}cart/change.js`
          : '/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: key, quantity }),
        });

        if (!response.ok) throw new Error('Cart update failed');
        window.location.reload();
      } catch (error) {
        console.error(error);
        window.alert('Could not update quantity. Please try again.');
        setUpdating(false);
      }
    };

    root.querySelectorAll('[data-qty]').forEach((stepper) => {
      const input = stepper.querySelector('.nimizo-bag__qty-input');
      if (!input) return;

      stepper.querySelectorAll('[data-qty-change]').forEach((btn) => {
        btn.addEventListener('click', () => {
          const delta = Number(btn.getAttribute('data-qty-change'));
          const next = Math.max(0, Number(input.value || 0) + delta);
          input.value = String(next);
          updateQuantities(input.dataset.lineKey, next);
        });
      });

      input.addEventListener('change', () => {
        const next = Math.max(0, Number(input.value || 0));
        input.value = String(next);
        updateQuantities(input.dataset.lineKey, next);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const toggleBtn = document.getElementById('filterToggleBtn');
    const closeBtn = document.getElementById('filterCloseBtn');
    const sidebar = document.getElementById('filterSidebar');
    const overlay = document.getElementById('filterOverlay');

    function openFilters() {
      if (!sidebar) return;
      sidebar.classList.add('is-open');
      if (overlay) {
        overlay.hidden = false;
        overlay.classList.add('is-open');
      }
      document.body.style.overflow = 'hidden';
    }

    function closeFilters() {
      if (!sidebar) return;
      sidebar.classList.remove('is-open');
      if (overlay) {
        overlay.classList.remove('is-open');
        overlay.hidden = true;
      }
      document.body.style.overflow = '';
    }

    if (toggleBtn) toggleBtn.addEventListener('click', openFilters);
    if (closeBtn) closeBtn.addEventListener('click', closeFilters);
    if (overlay) overlay.addEventListener('click', closeFilters);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
  function filterFaq(category, btn) {
    document.querySelectorAll('.faq-cat-btn').forEach(b => b.classList.remove('active'));
    btn.classList.add('active');

    document.querySelectorAll('.faq-category-block').forEach(block => {
      if (category === 'all' || block.getAttribute('data-category') === category) {
        block.style.display = 'block';
      } else {
        block.style.display = 'none';
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const toggleBtn = document.getElementById('nimizoMobileMenuToggle');
    const closeBtn = document.getElementById('nimizoDrawerCloseBtn');
    const drawer = document.getElementById('nimizoMobileDrawer');
    const overlay = document.getElementById('nimizoDrawerOverlay');

    function openDrawer() {
      if (drawer && overlay) {
        drawer.classList.add('is-active');
        overlay.classList.add('is-active');
        document.body.style.overflow = 'hidden';
      }
    }

    function closeDrawer() {
      if (drawer && overlay) {
        drawer.classList.remove('is-active');
        overlay.classList.remove('is-active');
        document.body.style.overflow = '';
      }
    }

    if (toggleBtn) toggleBtn.addEventListener('click', openDrawer);
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    if (overlay) overlay.addEventListener('click', closeDrawer);

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') closeDrawer();
    });
  });

  /* Restyle Joy Wishlist header icon to match Nimizo icon buttons */
  (function () {
    var STYLE_ID = 'nimizo-joy-wishlist-header-style';
    var css = [
      'button{',
      'display:inline-flex!important;align-items:center!important;justify-content:center!important;',
      'width:42px!important;height:42px!important;padding:0!important;margin:0!important;',
      'border:none!important;border-radius:50%!important;',
      'background-color:var(--color-bg-light,#F8F9FA)!important;',
      'color:var(--color-charcoal,#222)!important;cursor:pointer!important;',
      'box-sizing:border-box!important;transition:background-color .2s ease,color .2s ease!important;',
      '--joy-wl-access-icon-color:var(--color-charcoal,#222)!important;',
      '--joy-wl-access-badge-bg:var(--color-coral,#FF6B81)!important;',
      '--joy-wl-access-badge-color:#fff!important;',
      '}',
      'button:hover{background-color:var(--color-pink-light,#FFF0F2)!important;color:var(--color-coral,#FF6B81)!important;}',
      '.Joy-Wishlist-AccessButton__Icon{display:flex!important;align-items:center!important;justify-content:center!important;line-height:0!important;}',
      '.Joy-Wishlist-AccessButton__Icon svg{width:20px!important;height:20px!important;display:block!important;}',
      '.Joy-Wishlist-AccessButton__Icon svg path{',
      'fill:none!important;stroke:var(--color-charcoal,#222)!important;stroke-width:1.8!important;',
      '}',
      'button:hover .Joy-Wishlist-AccessButton__Icon svg path{stroke:var(--color-coral,#FF6B81)!important;}',
      '.Joy-Wishlist-AccessButton__AddedItem{',
      'top:-2px!important;right:-2px!important;width:20px!important;height:20px!important;',
      'min-width:20px!important;border-radius:50%!important;',
      'background-color:var(--color-coral,#FF6B81)!important;color:#fff!important;',
      'font-size:.75rem!important;font-weight:700!important;line-height:1!important;',
      'display:flex!important;align-items:center!important;justify-content:center!important;',
      'border:2px solid #fff!important;box-sizing:border-box!important;',
      '}'
    ].join('');

    function styleHost(host) {
      if (!host || !host.shadowRoot) return;
      var root = host.shadowRoot;
      var existing = root.getElementById(STYLE_ID);
      if (!existing) {
        var style = document.createElement('style');
        style.id = STYLE_ID;
        style.textContent = css;
        root.appendChild(style);
      }
    }

    function styleAll() {
      document.querySelectorAll('joy-wishlist-icon[variant="header"], joy-wishlist-icon').forEach(styleHost);
    }

    styleAll();
    document.addEventListener('DOMContentLoaded', styleAll);
    var observer = new MutationObserver(function () { styleAll(); });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    let mainImg = document.getElementById('pdpMainImage');
    const mainImgWrapper = document.getElementById('pdpMainImageWrapper');
    const thumbsWrap = document.getElementById('pdpGalleryThumbs');
    const stickyBarLeft = document.querySelector('#pdpStickyBar .sticky-bar-left');
    let stickyBarImg = document.querySelector('#pdpStickyBar img');
    const galleryRoot = document.getElementById('pdpGallery');
    const hasRealVariants = galleryRoot?.dataset.hasRealVariants === 'true';
    const productThumbsHTML = thumbsWrap && thumbsWrap.dataset.mode === 'product' ? thumbsWrap.innerHTML : '';
    let thumbBtns = () => Array.from(document.querySelectorAll('#pdpGalleryThumbs .pdp-thumb-btn'));

    function ensureMainImage() {
      mainImg = document.getElementById('pdpMainImage');
      if (mainImg || !mainImgWrapper) return mainImg;
      const placeholder = mainImgWrapper.querySelector('.pdp-gallery__placeholder');
      if (placeholder) placeholder.remove();
      mainImg = document.createElement('img');
      mainImg.id = 'pdpMainImage';
      mainImg.className = 'pdp-gallery__main-image';
      mainImg.width = 1000;
      mainImg.height = 1000;
      mainImg.loading = 'eager';
      mainImg.alt = '';
      mainImgWrapper.appendChild(mainImg);
      return mainImg;
    }

    function ensureStickyBarImage() {
      stickyBarImg = document.querySelector('#pdpStickyBar img');
      if (stickyBarImg || !stickyBarLeft) return stickyBarImg;
      stickyBarImg = document.createElement('img');
      stickyBarImg.width = 44;
      stickyBarImg.height = 44;
      stickyBarImg.alt = '';
      stickyBarLeft.insertBefore(stickyBarImg, stickyBarLeft.firstChild);
      return stickyBarImg;
    }

    function bindThumbClicks() {
      thumbBtns().forEach((btn) => {
        btn.onclick = function () {
          thumbBtns().forEach((b) => b.classList.remove('active'));
          this.classList.add('active');
          const img = ensureMainImage();
          if (img) {
            img.src = this.getAttribute('data-image-src');
            img.alt = this.getAttribute('data-alt') || img.alt;
            if (this.dataset.mediaId) img.dataset.mediaId = this.dataset.mediaId;
          }
          const sticky = ensureStickyBarImage();
          if (sticky) sticky.src = this.querySelector('img')?.src || sticky.src;
        };
      });
    }
    bindThumbClicks();

    function setMainImage(src, alt, thumbSrc, mediaId) {
      if (!src) return;
      const img = ensureMainImage();
      if (!img) return;
      img.src = src;
      if (alt) img.alt = alt;
      if (mediaId) img.dataset.mediaId = String(mediaId);
      const sticky = ensureStickyBarImage();
      if (sticky) sticky.src = thumbSrc || src;
    }

    function renderVariantGallery(images) {
      if (!thumbsWrap || !images || !images.length) return false;
      thumbsWrap.hidden = false;
      thumbsWrap.style.display = '';
      thumbsWrap.dataset.mode = 'variant';
      thumbsWrap.innerHTML = images
        .map(function (img, i) {
          const active = i === 0 ? ' active' : '';
          const id = img.id != null ? String(img.id) : 'meta-' + i;
          const alt = (img.alt || '').replace(/"/g, '&quot;');
          const source = i === 0 ? 'featured' : 'metafield';
          return (
            '<button type="button" class="pdp-thumb-btn' +
            active +
            '" data-image-src="' +
            img.src +
            '" data-media-id="' +
            id +
            '" data-alt="' +
            alt +
            '" data-source="' +
            source +
            '" aria-label="View variant image ' +
            (i + 1) +
            '">' +
            '<img src="' +
            (img.thumb || img.src) +
            '" alt="" width="80" height="80" loading="lazy">' +
            '</button>'
          );
        })
        .join('');
      bindThumbClicks();
      setMainImage(images[0].src, images[0].alt, images[0].thumb, images[0].id);
      return true;
    }

    function showAllProductMedia() {
      if (!thumbsWrap) return;
      if (productThumbsHTML) {
        thumbsWrap.innerHTML = productThumbsHTML;
        thumbsWrap.dataset.mode = 'product';
        thumbsWrap.hidden = false;
        thumbsWrap.style.display = '';
        bindThumbClicks();
      }
      const all = thumbBtns();
      all.forEach((btn, i) => {
        btn.hidden = false;
        btn.style.display = '';
        btn.classList.toggle('active', i === 0);
      });
      if (all[0]) {
        setMainImage(
          all[0].dataset.imageSrc,
          all[0].dataset.alt,
          all[0].querySelector('img')?.src,
          all[0].dataset.mediaId
        );
      }
    }

    function updateGallery(variant) {
      if (!variant) return;

      // No real variants: always show every product media image
      if (!hasRealVariants) {
        showAllProductMedia();
        return;
      }

      const inv = inventoryMap[variant.id] || {};
      let gallery = Array.isArray(inv.gallery) ? inv.gallery.filter((img) => img && img.src) : [];

      // Variant main image first, then metafield gallery images
      if (inv.featured_image) {
        const featuredId = inv.featured_media_id != null ? String(inv.featured_media_id) : null;
        const alreadyFirst =
          gallery.length &&
          ((featuredId && String(gallery[0].id) === featuredId) || gallery[0].src === inv.featured_image);
        const alreadyIn = gallery.some(
          (img) => (featuredId && String(img.id) === featuredId) || img.src === inv.featured_image
        );
        if (!alreadyIn) {
          gallery = [
            {
              id: inv.featured_media_id,
              src: inv.featured_image,
              thumb: inv.featured_image_thumb || inv.featured_image,
              alt: '',
            },
          ].concat(gallery);
        } else if (!alreadyFirst) {
          const featured = gallery.find(
            (img) => (featuredId && String(img.id) === featuredId) || img.src === inv.featured_image
          );
          gallery = [featured].concat(gallery.filter((img) => img !== featured));
        }
      }

      if (gallery.length) {
        renderVariantGallery(gallery);
        return;
      }

      // Variant with no featured image and no metafield gallery: clear thumbs / keep blank
      if (thumbsWrap) {
        thumbsWrap.innerHTML = '';
        thumbsWrap.hidden = true;
        thumbsWrap.dataset.mode = 'variant';
      }
    }

    const qtyInput = document.getElementById('pdpQtyInput');
    const qtyMinus = document.getElementById('qtyMinus');
    const qtyPlus = document.getElementById('qtyPlus');

    if (qtyMinus && qtyInput) {
      qtyMinus.addEventListener('click', () => {
        let val = parseInt(qtyInput.value) || 1;
        if (val > 1) {
          qtyInput.value = val - 1;
          qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    }
    if (qtyPlus && qtyInput) {
      qtyPlus.addEventListener('click', () => {
        let val = parseInt(qtyInput.value) || 1;
        qtyInput.value = val + 1;
        qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }

    const variantIdInput = document.getElementById('selectedVariantId');
    const metaList = document.getElementById('pdpMetaList');
    const priceCurrent = document.getElementById('pdpPriceCurrent');
    const priceCompare = document.getElementById('pdpPriceCompare');
    const addBtn = document.getElementById('pdpAddToCartBtn');
    const stickyAddBtn = document.getElementById('pdpStickyAddBtn');

    let productVariants = [];
    let inventoryMap = {};
    try {
      productVariants = JSON.parse(document.getElementById('NimizoProductVariants')?.textContent || '[]');
    } catch (e) {
      productVariants = [];
    }
    try {
      const inv = JSON.parse(document.getElementById('NimizoProductInventory')?.textContent || '[]');
      inv.forEach((row) => { inventoryMap[row.id] = row; });
    } catch (e) {
      inventoryMap = {};
    }

    const lowStockThreshold = Number(metaList?.dataset.lowStockThreshold || 5);
    const deliveryLeadDays = Number(metaList?.dataset.deliveryLeadDays || 3);
    const orderCutoffHour = Number(metaList?.dataset.orderCutoffHour || 17);
    const timezone = metaList?.dataset.timezone || 'Asia/Karachi';

    function formatMoney(cents) {
      if (cents == null) return '';
      if (window.Shopify && typeof Shopify.formatMoney === 'function') {
        try {
          return Shopify.formatMoney(cents, window.theme?.moneyFormat || undefined);
        } catch (e) {}
      }
      return 'Rs.' + (Number(cents) / 100).toLocaleString('en-PK', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    }

    function getSelectedOptionValues() {
      return Array.from(document.querySelectorAll('.pdp-variant-group')).map((group) => {
        const selected = group.querySelector('.pdp-swatch-btn.selected');
        return selected ? selected.getAttribute('data-value') : null;
      });
    }

    function findMatchingVariant(optionValues) {
      if (!optionValues.length || optionValues.some((v) => v == null)) return null;
      return (
        productVariants.find(
          (variant) =>
            Array.isArray(variant.options) &&
            variant.options.length === optionValues.length &&
            variant.options.every((opt, index) => opt === optionValues[index])
        ) || null
      );
    }

    function updateStockUI(variant) {
      if (!variant) return;
      const inv = inventoryMap[variant.id] || {};
      const available = inv.available !== false && variant.available !== false;
      const managed = Boolean(inv.inventory_management);
      const qty = Number(inv.inventory_quantity || 0);

      // Keep urgency card stock in sync with live variant inventory
      const urgency = document.querySelector('[data-pdp-urgency]');
      if (urgency) {
        const stockEl = urgency.querySelector('[data-urgency-stock]');
        const stockText = urgency.querySelector('[data-urgency-stock-text]');
        const barEl = urgency.querySelector('[data-urgency-bar]');
        const barFill = urgency.querySelector('[data-urgency-bar-fill]');
        const showStock = managed && available && qty > 0;
        if (stockEl) stockEl.hidden = !showStock;
        if (barEl) barEl.hidden = !showStock;
        if (showStock && stockText) {
          stockText.textContent =
            'Only ' + qty + ' item' + (qty === 1 ? '' : 's') + ' left in stock!';
        }
        if (showStock && barFill) {
          const cap = 20;
          let pct = qty >= cap ? 100 : Math.round((qty / cap) * 100);
          if (pct < 8) pct = 8;
          barFill.style.width = pct + '%';
        }
      }

      const labelAvailable =
        addBtn?.dataset.labelAvailable || stickyAddBtn?.dataset.labelAvailable || 'Add to Cart';
      const labelUnavailable =
        addBtn?.dataset.labelUnavailable || stickyAddBtn?.dataset.labelUnavailable || 'Out of stock';

      [addBtn, stickyAddBtn].forEach((btn) => {
        if (!btn) return;
        btn.disabled = !available;
        if (!available) {
          btn.setAttribute('aria-disabled', 'true');
          btn.setAttribute('data-atc-state', 'idle');
        } else {
          btn.removeAttribute('aria-disabled');
        }
        const label = btn.querySelector('[data-atc-label]');
        if (label) label.textContent = available ? labelAvailable : labelUnavailable;
      });

      const checkout = document.getElementById('pdpDynamicCheckout');
      if (checkout) {
        checkout.classList.toggle('is-unavailable', !available);
        checkout.setAttribute('aria-hidden', available ? 'false' : 'true');
        checkout.querySelectorAll('button, input, .shopify-payment-button__button').forEach((el) => {
          el.disabled = !available;
          if (!available) el.setAttribute('aria-disabled', 'true');
          else el.removeAttribute('aria-disabled');
        });
      }

      ['pdpQtyInput', 'qtyMinus', 'qtyPlus'].forEach((id) => {
        const el = document.getElementById(id);
        if (!el) return;
        el.disabled = !available;
      });
    }

    function updatePriceUI(variant) {
      if (!variant) return;
      const inv = inventoryMap[variant.id] || {};
      const price = inv.price != null ? inv.price : variant.price;
      const compare = inv.compare_at_price != null ? inv.compare_at_price : variant.compare_at_price;

      if (window.NimizoPdpOffers?.refreshForVariant && price != null) {
        window.NimizoPdpOffers.refreshForVariant(price, compare || price);
        return;
      }

      if (priceCurrent && price != null) priceCurrent.textContent = formatMoney(price);
      const stickyPrice = document.getElementById('pdpStickyPrice');
      if (stickyPrice && price != null) stickyPrice.textContent = formatMoney(price);
      const priceSave = document.getElementById('pdpPriceSave');
      if (priceCompare) {
        if (compare && compare > price) {
          priceCompare.textContent = formatMoney(compare);
          priceCompare.hidden = false;
          if (priceSave) {
            const saveAmt = compare - price;
            const savePct = Math.round((saveAmt * 100) / compare);
            priceSave.hidden = false;
            priceSave.textContent = 'Save ' + formatMoney(saveAmt) + ' (' + savePct + '%)';
          }
        } else {
          priceCompare.hidden = true;
          if (priceSave) {
            priceSave.hidden = true;
            priceSave.textContent = '';
          }
        }
      }
    }

    function getKarachiParts(date) {
      const parts = new Intl.DateTimeFormat('en-US', {
        timeZone: timezone,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false,
        weekday: 'short',
      }).formatToParts(date);
      const map = {};
      parts.forEach((p) => { if (p.type !== 'literal') map[p.type] = p.value; });
      return map;
    }

    function karachiDateFromParts(map, hour, minute, second) {
      // Build an absolute Date representing that Karachi wall-clock time via offset probe
      const guess = new Date(Date.UTC(
        Number(map.year),
        Number(map.month) - 1,
        Number(map.day),
        hour,
        minute,
        second || 0
      ));
      const asParts = getKarachiParts(guess);
      const wantedMin = hour * 60 + minute;
      const actualMin = Number(asParts.hour) * 60 + Number(asParts.minute);
      const diffMin = wantedMin - actualMin;
      return new Date(guess.getTime() + diffMin * 60 * 1000);
    }

    function addBusinessDays(startDate, days) {
      const d = new Date(startDate.getTime());
      let added = 0;
      while (added < days) {
        d.setUTCDate(d.getUTCDate() + 1);
        const wd = getKarachiParts(d).weekday;
        if (wd !== 'Sun') added += 1; // skip Sunday
      }
      return d;
    }

    function formatDeliveryDate(date) {
      return new Intl.DateTimeFormat('en-US', {
        timeZone: timezone,
        weekday: 'long',
        month: 'short',
        day: 'numeric',
      }).format(date);
    }

    function updateDeliveryUI() {
      const countdownEl = document.getElementById('deliveryCountdown');
      const dateEl = document.getElementById('deliveryDate');
      if (!countdownEl || !dateEl) return;

      const now = new Date();
      const parts = getKarachiParts(now);
      let cutoff = karachiDateFromParts(parts, orderCutoffHour, 0, 0);
      let shipStart = karachiDateFromParts(parts, 0, 0, 0);

      if (now >= cutoff) {
        // Next day cutoff
        const tomorrow = new Date(shipStart.getTime() + 24 * 60 * 60 * 1000);
        const tParts = getKarachiParts(tomorrow);
        cutoff = karachiDateFromParts(tParts, orderCutoffHour, 0, 0);
        shipStart = karachiDateFromParts(tParts, 0, 0, 0);
      }

      // If ship start is Sunday, move to Monday
      if (getKarachiParts(shipStart).weekday === 'Sun') {
        shipStart = new Date(shipStart.getTime() + 24 * 60 * 60 * 1000);
        const sParts = getKarachiParts(shipStart);
        cutoff = karachiDateFromParts(sParts, orderCutoffHour, 0, 0);
      }

      const deliveryDate = addBusinessDays(shipStart, deliveryLeadDays);
      dateEl.textContent = formatDeliveryDate(deliveryDate);

      let diffMs = cutoff.getTime() - now.getTime();
      if (diffMs < 0) diffMs = 0;
      const totalMins = Math.floor(diffMs / 60000);
      const hours = Math.floor(totalMins / 60);
      const mins = totalMins % 60;
      countdownEl.textContent = String(hours).padStart(2, '0') + 'h ' + String(mins).padStart(2, '0') + 'm';
    }

    function syncVariantSelection(sourceBtn) {
      if (sourceBtn) {
        const optionName = sourceBtn.getAttribute('data-option-name');
        const val = sourceBtn.getAttribute('data-value');
        const parent = sourceBtn.closest('.pdp-swatch-options');
        if (parent) {
          parent.querySelectorAll('.pdp-swatch-btn').forEach((b) => b.classList.remove('selected'));
        }
        sourceBtn.classList.add('selected');
        const valLabel = document.getElementById('selectedVal-' + optionName);
        if (valLabel) valLabel.textContent = val;
      }

      let matched = findMatchingVariant(getSelectedOptionValues());
      if (!matched && productVariants.length === 1) matched = productVariants[0];

      if (matched && variantIdInput) {
        const previousId = variantIdInput.value;
        variantIdInput.value = String(matched.id);
        updateStockUI(matched);
        updatePriceUI(matched);
        updateGallery(matched);
        const skuEl = document.getElementById('pdpSkuValue');
        if (skuEl && inventoryMap[matched.id]) {
          skuEl.textContent = inventoryMap[matched.id].sku || '';
        }
        document.dispatchEvent(
          new CustomEvent('nimizo:variant:change', {
            detail: {
              previousVariantId: previousId ? Number(previousId) : null,
              variantId: matched.id,
              variant: matched,
              available: matched.available !== false,
            },
          })
        );
      }
    }

    const swatchBtns = document.querySelectorAll('.pdp-swatch-btn');
    swatchBtns.forEach((btn) => {
      btn.addEventListener('click', function () {
        syncVariantSelection(this);
      });
    });

    // Initial sync for single-variant and multi-variant products
    syncVariantSelection();
    updateDeliveryUI();
    setInterval(updateDeliveryUI, 30000);

    const stickyBar = document.getElementById('pdpStickyBar');
    if (stickyAddBtn) {
      stickyAddBtn.addEventListener('click', function () {
        if (stickyAddBtn.disabled) return;
        addBtn?.click();
      });
    }
    if (stickyBar && addBtn) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) {
            stickyBar.classList.add('is-visible');
          } else {
            stickyBar.classList.remove('is-visible');
          }
        });
      }, { threshold: 0.1 });

      observer.observe(addBtn);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const toggleBtn = document.getElementById('searchFilterToggle');
    const closeBtn = document.getElementById('searchFilterClose');
    const sidebar = document.getElementById('searchFilterSidebar');
    const overlay = document.getElementById('searchFilterOverlay');

    function openFilters() {
      if (!sidebar) return;
      sidebar.classList.add('is-open');
      if (overlay) {
        overlay.hidden = false;
        overlay.classList.add('is-open');
      }
      document.body.style.overflow = 'hidden';
    }

    function closeFilters() {
      if (!sidebar) return;
      sidebar.classList.remove('is-open');
      if (overlay) {
        overlay.classList.remove('is-open');
        overlay.hidden = true;
      }
      document.body.style.overflow = '';
    }

    if (toggleBtn) toggleBtn.addEventListener('click', openFilters);
    if (closeBtn) closeBtn.addEventListener('click', closeFilters);
    if (overlay) overlay.addEventListener('click', closeFilters);
  });

  } catch(e) { console.error(e); }
})();
})();
